import React from "react";

// Titan Car Rentals — Official brand logo
// Uses the brand artwork served from /titan-logo.png in public.
// `variant`:
//   - "dark"  (default) — for light/white backgrounds (no wrapper)
//   - "light" — for dark backgrounds (wraps in a white badge)
export function TitanLogo({ variant = "dark", size = "md", className = "" }) {
  const sizes = {
    sm: 40,
    md: 56,
    lg: 90,
    xl: 140,
  };
  const h = sizes[size] || sizes.md;

  const img = (
    <img
      src="/titan-logo.png"
      alt="Titan Car Rentals"
      style={{ height: h, width: "auto", display: "block" }}
      data-testid="titan-logo-img"
    />
  );

  if (variant === "light") {
    return (
      <div
        className={`bg-white rounded-sm inline-flex items-center justify-center ${className}`}
        style={{ padding: Math.round(h * 0.08) }}
        data-testid="titan-logo"
      >
        {img}
      </div>
    );
  }

  return (
    <div className={`inline-flex items-center ${className}`} data-testid="titan-logo">
      {img}
    </div>
  );
}

export default TitanLogo;
